const enum ENDPOINTS {
    LOGIN =  'Auth/login',
    REFRESH_TOKEN = 'Auth/refresh',
    REGISTER = 'Auth/register',
    LESSONS = 'Lessons',
    COURSES = 'Courses',
    ORGANIZATIONS = 'Organizations',
    TEST_CONTROLLERS = 'Tests',
    GROUPS = 'Groups',
    PROFILES = 'Profiles',
    ATTESTATIONS = 'Attestations',
};

export default ENDPOINTS;